import { SearchGlyphProps } from './SearchGlyphLoading';
import isSearchSessionActive from '../selectors/isSearchSessionActive';
import { observer } from 'mobx-react-lite';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { exitSearchTooltip } from 'owa-locstrings/lib/strings/exitsearchtooltip.locstring.json';
import * as React from 'react';

const classNames = require('classnames');
const styles = require('./SearchGlyph.scss');

export default observer(function SearchGlyph(props: SearchGlyphProps): JSX.Element {
    const {
        onClick,
        searchBoxHasFocus,
        useNextSearchBoxInteractions,
        isSearchBoxDisabled,
        scenarioId,
    } = props;

    const searchGlyphClassNames = React.useMemo(
        () =>
            getSearchGlyphClasses(
                useNextSearchBoxInteractions,
                searchBoxHasFocus,
                isSearchBoxDisabled
            ),
        [useNextSearchBoxInteractions, searchBoxHasFocus, isSearchBoxDisabled]
    );

    if (useNextSearchBoxInteractions || !isSearchSessionActive(scenarioId)) {
        return (
            <div aria-hidden={true} className={searchGlyphClassNames} onClick={onClick}>
                <Icon iconName={ControlIcons.Search} />
            </div>
        );
    }

    return (
        <IconButton
            className={classNames(styles.backButton, 'flipForRtl')}
            iconProps={{ iconName: ControlIcons.Back }}
            onClick={onClick}
            ariaLabel={loc(exitSearchTooltip)}
            title={loc(exitSearchTooltip)}
        />
    );
});

const getSearchGlyphClasses = (
    useNextSearchBoxInteractions: boolean,
    searchBoxHasFocus: boolean,
    isSearchBoxDisabled: boolean
) => {
    if (useNextSearchBoxInteractions) {
        return classNames(
            searchBoxHasFocus ? styles.searchIconFocused : styles.searchIconRest,
            isSearchBoxDisabled && styles.isDisabled
        );
    }

    return classNames(styles.searchIcon, isSearchBoxDisabled && styles.isDisabled);
};
